import { JobseekerLookupResolveService } from './shared/services/jobseeker-lookup-resolve.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { JobseekersShellComponent } from './jobseekers-shell/jobseekers-shell.component';
import { JobseekerListComponent } from './jobseeker-list/jobseeker-list.component';
import { JobseekerViewEditComponent } from './jobseeker-view-edit/jobseeker-view-edit.component';
import { RouteApplicationStartupResolveService } from '../core/route-application-startup-resolve.service';
import { ModerationJobseekerComponent } from './moderation-jobseeker/moderation-jobseeker.component';
import { AuthGuard } from '../core/auth.guard';

const jobseekersRoutes: Routes = [
  {
    path: 'jobseekers',
    component: JobseekersShellComponent,
    canActivate: [AuthGuard],
    resolve: {
      appData: RouteApplicationStartupResolveService,
      lookupData: JobseekerLookupResolveService,
    },
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        component: JobseekerListComponent,
      },
      {
        path: 'edit/:id',
        component: JobseekerViewEditComponent,
        //TODO resolver
      },
      {
        path: 'moderation/:jobseekerId',
        component: ModerationJobseekerComponent,
        //TODO resolver
      },
    ],
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(jobseekersRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class JobseekersRoutingModule {}
